import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper for weighted random
export const getWeightedRandomPrize = (items) => {
  if (!items || items.length === 0) return null;
  const totalWeight = items.reduce((sum, item) => sum + (item.weight || 1), 0);
  let random = Math.random() * totalWeight;
  for (const item of items) {
    if (random < (item.weight || 1)) return item;
    random -= (item.weight || 1);
  }
  return items[items.length - 1];
};

// Fallback mock data in case DB tables don't exist yet
export const MOCK_PRIZES = [
  { id: 1, label: '大吉！特大ボーナス', points: 500, weight: 5, icon: '💎' },
  { id: 2, label: '中吉！嬉しいボーナス', points: 100, weight: 20, icon: '⭐' },
  { id: 3, label: '小吉！コツコツ貯めよう', points: 50, weight: 45, icon: '🪙' },
  { id: 4, label: '参加賞', points: 10, weight: 30, icon: '🍀' }
];